/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function EmojiPaperplane({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M14.256 1.925a.593.593 0 0 1 .753.682l-1.719 8.795a.61.61 0 0 1-.31.42.6.6 0 0 1-.519.026l-2.832-1.203-2.576 3.23a.6.6 0 0 1-1.069-.375V9.098l-.098-.042L.776 7.06A.59.59 0 0 1 .4 6.476a.61.61 0 0 1 .435-.55zM7.184 9.607v2.179l1.298-1.627zM2.845 6.574 6.04 7.822l5.18-3.744zm9.412 3.877 1.286-6.581L7.33 8.36z" clipRule="evenodd" /></svg>;
}
;